import {useListView} from '../../core/ListViewProvider'
import {ListToolbar} from './ListToolbar'
import {ListGrouping} from './ListGrouping'
import {SearchComponent} from './SearchComponent'
import {TOKENS} from '../../../../../../components/design-system'

type PropTypes = {
  showAddOperator?: boolean
}

const ListHeader = ({showAddOperator = true}: PropTypes) => {
  const {selected} = useListView()
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: TOKENS.spacing.md,
        padding: '14px 18px',
        borderBottom: `1px solid ${TOKENS.color.border}`,
        background: TOKENS.color.card,
      }}
    >
      <SearchComponent />
      <div>
        {selected.length > 0 ? <ListGrouping /> : <ListToolbar showAddOperator={showAddOperator} />}
      </div>
    </div>
  )
}

export {ListHeader}
